import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import todoCollection from "../firebase-config";
import { addDoc, updateDoc, doc } from "firebase/firestore";
import { useSelector } from "react-redux";
import { db } from "../firebase-config";

const CreateTodo = () => {
  const { id } = useParams();
  const todoSelector = useSelector((state) => state.todo.todos);
  const [boolId, setBoolId] = useState(false);
  const [todoDict, setTodoDict] = useState({
    title: "",
    description: "",
  });

  const getItem = () => {
    if (id) {
      try {
        setBoolId(true);
        const filtered = todoSelector.filter((item) => {
          return item.id === id;
        })[0];
        setTodoDict(filtered);
      } catch (error) {}
    }
  };
  useEffect(() => {
    getItem();
  }, []);

  const navigate = useNavigate();

  const changed = (event) => {
    let name = event.target.name;
    let invalue = event.target.value;
    setTodoDict((preValue) => {
      return {
        ...preValue,
        [name]: invalue,
      };
    });
  };

  const submitted = (event) => {
    event.preventDefault();
    if (boolId) {
      const mydoc = doc(db, "todos", id);
      updateDoc(mydoc, todoDict);
      console.log("updated");
    } else {
      addDoc(todoCollection, todoDict);
      console.log("added");
    }
    navigate("/");
  };

  return (
    <InputDiv>
      <div>
        <form onSubmit={submitted}>
          <Input
            type="text"
            placeholder="Title"
            name="title"
            onChange={changed}
            value={todoDict.title}
          ></Input>
          <TextArea
            placeholder="Description"
            name="description"
            onChange={changed}
            value={todoDict.description}
          ></TextArea>
          <Button type="submit">
            <AddIcon />
          </Button>
        </form>
      </div>
    </InputDiv>
  );
};

export default CreateTodo;

const InputDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 35px;
  & > div {
    width: 35vw;
    padding: 30px;
    background-color: rgb(255, 255, 255);
    box-shadow: 3px 3px 15px 3px rgb(228, 221, 221);
    border-radius: 10px;
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  font-family: poppins;
  margin-bottom: 20px;
  border: 1px solid rgb(218, 218, 218);
  border-radius: 8px;
  &:focus {
    outline: none;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  font-size: 1rem;
  font-family: poppins;
  border: 1px solid rgb(218, 218, 218);
  border-radius: 10px;
  &:focus {
    outline: none;
  }
`;

const Button = styled.button`
  width: 60px;
  height: 60px;
  border-radius: 100px;
  border: none;
  background-color: yellow;
  position: absolute;
  top: 42%;
  right: 31%;
  &:hover {
    box-shadow: 3px 3px 10px 3px rgb(238, 234, 234);
    cursor: pointer;
    transition: all 0.3s;
    color: rgb(0, 0, 0);
    background-color: rgb(255, 255, 82);
  }
`;
